<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ezf1u3/tc-custom/9781952871504.jpg?1738699914445" alt="This image is the cover for the book Sugar Ain't So Sweet, Everything Nice Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sugar Ain't So Sweet, Everything Nice Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Shannan has no choice but to leave her husband, seven children, and a successful career before someone ends up on the wrong side of the grave.</b> As she escapes the manipulation and impossible demands of her husband and family, she embraces the 30 Days of Me process for reconnecting with her best self. She is determined to find peace and a new sense of purpose, but her husband, Zach, is desperate to win her back. As he struggles to deal with his overbearing family and disrespectful children, he is forced to confront hard truths and family secrets that threaten to push Shannan further away.<br/><br/>With emotional depth and a powerful narrative, <i>USA TODAY</i> Bestselling Author, Naleighna Kai and bestselling author, La Ammitai, deliver a tale of love, loss, and redemption in <i>Sugar Ain’t So Sweet.</i><br/><br/><b>ABOUT THE SUGAR SERIES</b><br/>Each book is a standalone, NO cliffhangers<br/><br/> Book 1 – Stop in the Name of Love by Naleighna Kai and U. M. Hiram<br/>Book 2 – Spice of Life by J. L. Campbell<br/>Book 3 – His Biggest Fan by Martha Kennerson<br/><br/><b>ABOUT THE SPICE SERIES</b><br/>Each book is a standalone, NO cliffhangers<br/><br/> Book 1 – Loving All of Me by Naleighna Kai and Stephanie M. Freeman<br/>Book 2 – Carnal Confections by Shakir Rashaan<br/>Book 3 – Dirty Diana by J. D. Mason<br/><br/><b>ABOUT THE EVERYTHING NICE SERIES</b><br/>Each book is a standalone, NO cliffhangers<br/><br/> Book 1 – Sugar Ain’t So Sweet by Naleighna Kai and LaAmmitai<br/>Book 2 – Spicing Things Up by Lisa Dodson<br/>Book 3 – Cayenne by Janice M. Allen
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Naleighna Kai, La Ammitai
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macro Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44c0af49